import { BrandRefreshBannerDebugSection } from './BrandRefreshBannerDebugSection'
import { BrandRefreshBetaDebugConsoleShim } from './BrandRefreshBetaDebugConsoleShim'
import { registerDebugChromeSlot, registerDebugPanelSection } from '../debug_tools/debugRegistry'
import { useShowDebugToolsPanel } from '../debug_tools/useShowDebugToolsPanel'

registerDebugPanelSection({
  id: 'brand-refresh-banner',
  title: 'Beta banner debug',
  removeBy: '2026-12-01',
  order: 10,
  Component: BrandRefreshBannerDebugSection,
})

/** Console shim must live in chrome (always mounted with the trigger), not PopoverContent. */
registerDebugChromeSlot({
  id: 'brand-refresh-beta-console',
  removeBy: '2026-12-01',
  order: 5,
  useVisible: useShowDebugToolsPanel,
  Component: BrandRefreshBetaDebugConsoleShim,
})
